import axios from 'axios';

const apiUrl = `https://hirecrap-backend-gcg3e8cmcgfwe6ef.westus2-01.azurewebsites.net/api/hirecrap`;

// Reusable API fetch function with caching
const fetchFromAPI = async (url, params = {}) => {
    try {
        const response = await axios.get(url, { params, timeout: 15000 });
        return response.data;
    } catch (error) {
        console.error(`Error fetching data from ${url}:`, error.message);
        throw error;
    }
};

// US BANANA
export const getUsBananaJobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/bananaus/jobById/${id}`);
};

export const getUsBananaJobs = async (page = 1, limit = 25) => {
    return fetchFromAPI(`${apiUrl}/bananaus/alljobs`, { page, limit });
};

export const getUsBananaJobsByTitle = async (title, page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/bananaus/search`, { title, page, limit});
};


// IN BANANA
export const getInBananaJobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/bananain/jobById/${id}`);
};

export const getInBananaJobs = async (page = 1, limit = 25) => {
    return fetchFromAPI(`${apiUrl}/bananain/alljobs`, { page, limit });
};

export const getInBananaJobsByTitle = async (title, page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/bananain/search`, { title, page, limit});
};

// UK BANANA
export const getUkBananaJobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/bananauk/jobById/${id}`);
};

export const getUkBananaJobs = async (page = 1, limit = 10) => {
    return fetchFromAPI(`${apiUrl}/bananauk/alljobs`, { page, limit });
};

export const getUkBananaJobsByTitle = async (title, page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/bananauk/search`, { title, page, limit});
};

// DE BANANA
export const getDeBananaJobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/bananade/jobById/${id}`);
};

export const getDeBananaJobs = async (page = 1, limit = 25) => {
    return fetchFromAPI(`${apiUrl}/bananade/alljobs`, { page, limit });
};

export const getDeBananaJobsByTitle = async (title, page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/bananade/search`, { title, page, limit});
};
